// extracted by mini-css-extract-plugin
module.exports = {"infoItemLabel":"InfoItem_infoItemLabel__2eblw","infoItemDescription":"InfoItem_infoItemDescription__3QxXD","infoItem":"InfoItem_infoItem__1fVbb"};